import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { EditorialModel } from 'src/app/models/Editorial.model';
import { NewsService } from 'src/app/services/News/news.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { MultiLangModel } from './../../../models/Language.model';
import { NewsFilterModel, NewsModel } from './../../../models/News.model';

@Component({
  selector: 'app-news-search-list',
  templateUrl: './news-search-list.page.html',
  styleUrls: ['./news-search-list.page.scss'],
  standalone: false,
})
export class NewsSearchListPage {
  constructor(
    private routeParams: ActivatedRoute,
    private newsService: NewsService,
    private shareService: SharedService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  news: NewsModel[] = [];
  filter: NewsFilterModel = { PageIndex: 0, PageSize: 20, Search: '', language: '' };
  editorials?: EditorialModel[];
  empty = true;
  notFound = true;
  Loading = true;
  moreResults = true;
  endResults = false;

  routeEditorialId: string = '';
  routeCategoryId: string = '';
  routeSearch: string = '';

  private filterSubject = new Subject<NewsFilterModel>();
  fakeElementsLarg = ['', '', '', '', '', ''];

  title = new MultiLangModel({
    pt: '',
    en: '',
    es: '',
  });

  ngOnInit() {
    this.Loading = true;
    this.empty = false;
    this.notFound = false;

    this.listNewsSwitch(this.filterSubject.asObservable()).subscribe(
      async (news: NewsModel[]) => {
        if (this.filter.Event) {
          if (news.length === 0) {
            this.moreResults = false;
            this.endResults = true;
            this.shareService.showToast(this.translate.instant('common.emptyResult'));
          } else {
            this.news = this.news.concat(news);
            this.moreResults = true;
            this.empty = false;
            this.notFound = false;
          }
        } else {
          news.length == 0 ? (this.empty = true) : (this.empty = false);
          this.notFound = false;
          this.news = news;
        }
        this.Loading = false;
      },
      () => {
        this.empty = false;
        this.notFound = true;
        this.Loading = false;
      },
    );
  }

  async ionViewWillEnter(scroll?: boolean) {
    if (scroll) {
      this.filter.PageIndex++;
      this.filter.Event = true;
      this.moreResults = false;
    } else {
      this.filter = {
        PageIndex: 0,
        PageSize: 20,
        language: this.translate.currentLang,
        Event: false,
      };
    }
    this.filter.Event ? (this.Loading = false) : (this.Loading = true);

    this.empty = false;
    this.notFound = false;

    this.routeEditorialId = this.routeParams.snapshot.paramMap.get('editorialId') ?? '';
    this.routeCategoryId = this.routeParams.snapshot.paramMap.get('categoryId') ?? '';
    this.routeSearch = this.routeParams.snapshot.paramMap.get('search') ?? '';

    this.routeEditorialId !== 'undefined' && this.routeEditorialId !== 'null' && this.routeEditorialId !== 'highlights'
      ? (this.filter.EditorialId = this.routeEditorialId)
      : null;

    this.routeCategoryId !== 'undefined' && this.routeCategoryId !== 'null'
      ? (this.filter.CategoryId = this.routeCategoryId)
      : null;

    this.routeSearch !== 'undefined' && this.routeSearch.length > 0 && this.routeSearch !== 'null'
      ? (this.filter.Search = this.routeSearch)
      : null;

    this.routeEditorialId === 'highlights' ? (this.filter.Highlights = true) : null;

    this.addFilterChange(this.filter);
  }

  listNewsSwitch(filter: Observable<NewsFilterModel>): Observable<NewsModel[]> {
    return filter.pipe(switchMap((filter: NewsFilterModel) => this.newsService.getNews(filter)));
  }

  addFilterChange(filter: NewsFilterModel) {
    this.filterSubject.next(filter);
  }

  async changeParams(id: string) {
    this.router.navigateByUrl(`panel/network/news/details/${this.routeEditorialId}/${id}`);
  }

  search() {
    this.Loading = true;
    this.news = [];
    this.filter.PageIndex = 0;
    this.addFilterChange(this.filter);
  }

  async ngOnDestroy() {
    this.filterSubject?.unsubscribe();
  }
}
